import Vue from "vue";
import { mapGetters } from "vuex";

import { CurrencyText, LoadingSpinner, PartDetailsLink } from "@/components";
import { stringHelper } from "@/components/mixins";
import { GridUtil } from "@/services/";

export default Vue.extend({
    name: "AlternativeParts",

    components: { CurrencyText, LoadingSpinner, PartDetailsLink },
    mixins: [stringHelper],

    props: {
        partAlternatives: {
            type: Array,
        },
        showGrid: {
            type: Function,
            required: true
        },
        oemPartCode:{
            type: String
        },
        busy:{
            type: Boolean
        }
    },

    computed: {
        ...mapGetters([
            "user",
            "activeAccountId",
            "canSeeAnyPrice",
            "canSeeContractPrice",
            "canSeeDealerNet",
            "getContentItem",
            "tenantDetails",
            "audienceIds"
        ]),

        showContractPricingMessage() {
            return this.partAlternatives && this.partAlternatives.some(x => x.isContractPrice);
        },

        canViewPrice() {
            return this.canSeeAnyPrice;
        },

        columns() {
            if (this.canViewPrice) {
                return this.allColumns;
            }
            return this.allColumns.filter((column: { key: string }) => column.key !== "price");
        },
    },

    created() {
        this.allColumns = GridUtil.localizeColumnLabels(this.allColumns, this.getContentItem);
    },

    data: () => ({
        allColumns: [
            { key: "oemPartCode", localizationKey: "PartNumber", sortable: false },
            { key: "partType", localizationKey: "replacementType", sortable: false },
            { key: "price", localizationKey: "price", sortable: false },
        ]
    }),
});
